module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-thin-rounded-LFWVTX5C.eot?113704fe2cffb14600c8a6094849c346";